<script setup lang="ts">
import type { NovaBoxCreatorContentBlockProps } from './NovaBoxCreatorContentBlock.types'

withDefaults(defineProps<NovaBoxCreatorContentBlockProps>(), {
  title: '',
  message: '',
  action: null,
})
</script>

<template>
  <div class="block-wrap">
    <div v-dompurify-html="title" class="title" />
    <div v-dompurify-html="message" class="message" />
    <NovaButtonText
      v-if="action"
      :label="action.label"
      :theme="action.theme"
      :responsive-size="{ desktop: 40, mobile: 32 }"
      :class="'btn-creator-block'"
      @click="action?.onClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.block-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  min-height: 300px;
  .title {
    padding-bottom: 20px;
    @include text-style($text-heading2-bold);
    word-break: break-all;
  }
  .message {
    @include text-style($text-heading3-bold);
  }
  .btn-creator-block {
    min-width: 125px;
    margin: 32px auto 0;
  }
}
</style>
